export const formatSubcategories = ({ category, links }) => {
  return category.subcategories.map((subcategory) => {
    return {
      ...subcategory,
      links: links
        .map((link) => {
          const currentFoundCategory = link.categories?.find(
            (linkCategory) => linkCategory.id === category.id
          );
          const foundSubcategory = currentFoundCategory?.subcategories?.find(
            (sc) => sc.id === subcategory.id
          );

          if (foundSubcategory) {
            return {
              ...link,
              subcategoryWeight: foundSubcategory.weight,
            };
          }
          return null;
        })
        .filter(Boolean),
    };
  });
};
